import { render, staticRenderFns } from "./ProductQuestions.vue?vue&type=template&id=cd6e238e&scoped=true&"
import script from "./ProductQuestions.vue?vue&type=script&lang=js&"
export * from "./ProductQuestions.vue?vue&type=script&lang=js&"
import style0 from "./ProductQuestions.vue?vue&type=style&index=0&id=cd6e238e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6e238e",
  null
  
)

export default component.exports